/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BankIDCompanyCheck } from './bank-id-company-check';
import { Address } from './address';
import { DealflowFile } from './dealflow-file';
import { TestStatusEnum } from './test-status-enum';

export interface DeckInvestmentCompanyDetail {
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly test_status: TestStatusEnum;
  readonly total_investment: number;
  readonly name: string;
  readonly id: string;
  readonly red: boolean;
  readonly agreement_url: string;
  readonly address: Address;
  readonly pep_data: BankIDCompanyCheck;
  readonly submission_counter: number;
  readonly dealflow_files: Array<DealflowFile>;
}
export namespace DeckInvestmentCompanyDetail {}
